import React from 'react';
import { connect } from 'dva';
import get from 'lodash-es/get';
import PropTypes from 'prop-types';
import { SIDEBAR_SAVED_TABS } from '../../../lib/constants'
import EditStylesFooter from './Footers/EditStylesFooter';
import SavedContent from './SavedContent';
import SelectedFeaturesFooter from './Footers/SelectedFeaturesFooter';
import SidebarDetailHeader from '../SidebarDetailHeader';

function SavedSidebar(props) {
  let footer = null;
  if (props.selectedFeaturesCount && props.tab == SIDEBAR_SAVED_TABS.Content) {
    if (props.isEditingFeature) {
      footer = <EditStylesFooter />;
    }
    else {
      footer = <SelectedFeaturesFooter />;
    }
  }

  return (
    <>
      <SidebarDetailHeader
        title="Hunts"
      />
      <SavedContent />
      {footer}
    </>
  );
}

SavedSidebar.propTypes = {
  isEditingFeature: PropTypes.bool,
  selectedFeaturesCount: PropTypes.number,
  tab: PropTypes.string,
};

export default connect((model) => {
  const { sidebarView } = model.app
  const { isEditingFeature, selectedFeaturesCount } = model.features
  const tab = get(sidebarView, ['metadata', 'savedContentTab'], SIDEBAR_SAVED_TABS.Content)
  return {
    isEditingFeature,
    selectedFeaturesCount,
    tab
  };
})(SavedSidebar);